export const css = {
	root: '_2gKd1u7h',
	' _key': 'backview/backview'
};

export default css;
